import { useParams, useSearchParams } from "react-router-dom";
import { getIntegrationMeta } from "./integrationRegistry.js";
import { GenericSettings } from "./components/GenericSettings.js";

export const IntegrationSettingsPage = () => {
  const { integrationId } = useParams();
  if (!integrationId) throw new Error("integrationId is missing");

  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") === "create" ? "create" : "edit";

  const meta = getIntegrationMeta(integrationId);
  const SettingsComponent = meta.Settings;

  if (SettingsComponent) {
    return <SettingsComponent integrationId={integrationId} mode={mode} />;
  }

  return <GenericSettings integrationId={integrationId} mode={mode} />;
};
